import NoticeBar from './noticeBar';
export default NoticeBar;
export { NoticeBar };